import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import {
  faCircleCheck,
  faEllipsisVertical,
  faEnvelope,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { User } from "../../providers/auth-provider";
import { Menu, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import GetUser from "../../utils/getUser";

interface TRenderRow {
  row: User;
  handleMenuToggle: (id: number) => void;
  menuOpen: number;
  tableAction: any[];
  noSpaceAction: boolean;
  rowIndex: number;
}

const RenderRow = ({ row: rowData, tableAction, rowIndex }: TRenderRow) => {
  const user = GetUser();
  const [row] = useState(rowData);
  const isSuperAdmin = user.type === "super-admin";
  const canManage = isSuperAdmin || (user.type === "admin" && row?.type === "agent");
  const actions = tableAction?.filter((action) => isSuperAdmin || !action.superAdminOnly);

  const statusIcon =
    row.status === "invite-sent"
      ? faEnvelope
      : row.type === "admin" || row?.type === "agent"
      ? faUserShield
      : faCircleCheck;

  return (
    <tr
      className="relative font-medium border-b border-edge-faint transition-colors duration-200 hover:bg-overlay-hover"
      key={row?.id}
    >
      <td className="w-[16%]">
        <p className="text-[16px] font-medium text-text-primary">
          {rowIndex === 0
            ? "🥇"
            : rowIndex === 1
            ? "🥈"
            : rowIndex === 2
            ? "🥉"
            : null}{" "}
          {row.name}
        </p>
      </td>

      <td className="text-light-gray py-3 w-[13%]">
        <p className="text-xs font-medium">{row?.code}</p>
      </td>
      <td className="text-light-gray py-3 w-[20%]">
        <p className="text-xs font-medium">{row?.email}</p>
        <p className="text-xs font-medium">{row?.phone}</p>
      </td>
      <td className="py-3 text-light-gray w-[12%]">
        <p className="text-xs font-medium">
          <span className="font-[600] text-text-primary">
            £{(Number(row?.collections) || 0)?.toFixed(2)}
          </span>
        </p>
      </td>
      <td className="py-3 text-light-gray w-[12%]">
        <p className="text-xs font-medium">
          <span className="font-[600] text-text-primary">
            £{(Number(row?.collectionsPlan) || 0)?.toFixed(2)}
          </span>
        </p>
      </td>

      <td className="py-3 text-light-gray w-[12%]">
        <p className="text-xs font-medium">{row?.type}</p>
      </td>
      <td className="py-3 text-light-gray w-[12%]">
        <div
          className={clsx(
            "flex gap-1 max-w-[100px] h-[26px] pl-2 rounded-2xl items-center border border-edge",
            row.status === "invite-sent" && "bg-slate-400/15 dark:bg-slate-500/15",
            (row.type === "admin" || row?.type === "agent") &&
              row.status !== "invite-sent" &&
              "bg-indigo-500/10 dark:bg-indigo-500/15",
            row.status !== "invite-sent" &&
              row.type !== "admin" &&
              row?.type !== "agent" &&
              "bg-emerald-500/10 dark:bg-emerald-500/15"
          )}
        >
          <FontAwesomeIcon
            icon={statusIcon}
            className={clsx(
              "text-[13px]",
              row?.status === "invite-sent" && "text-slate-500 dark:text-slate-400",
              (row.type === "admin" || row?.type === "agent") &&
                row.status !== "invite-sent" &&
                "text-indigo-600 dark:text-indigo-300",
              row.status !== "invite-sent" &&
                row.type !== "admin" &&
                row?.type !== "agent" &&
                "text-emerald-600 dark:text-emerald-300"
            )}
          />
          <p
            className={clsx(
              "text-[11px] font-medium !text-nowrap",
              row?.status === "invite-sent"
                ? "text-slate-600 dark:text-slate-400"
                : row?.type === "admin" || row?.type === "agent"
                ? "text-indigo-700 dark:text-indigo-200"
                : "text-emerald-700 dark:text-emerald-200"
            )}
          >
            {row?.type}
          </p>
        </div>
      </td>
      {tableAction && user.type !== "agent" && (
        <td className="text-end">
          {canManage && (
          <Menu as="div" className="relative inline-block text-right">
            <div>
              <Menu.Button>
                <button
                  data-bs-toggle="dropdown"
                  className="cursor-pointer h-8 w-8 rounded-full flex items-center justify-center border border-edge bg-overlay hover:bg-overlay-mid transition-colors duration-200"
                >
                  <FontAwesomeIcon
                    icon={faEllipsisVertical}
                    className="text-light-gray text-sm"
                  />
                </button>
              </Menu.Button>
            </div>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <div className="dropdown-menu p-[0] bg-transparent border-none absolute top-[20px] right-0 z-[99999]">
                <div
                  className={clsx(
                    "z-10 py-1 text-light-gray mt-2 w-[auto] min-w-[150px] rounded-xl bg-surface-elevated border border-edge shadow-card"
                  )}
                >
                  <div className="py-1">
                    {actions.map((action, index) => (
                      <div
                        key={index}
                        className="flex gap-2 px-4 py-2 text-xs text-light-gray items-center font-medium cursor-pointer hover:bg-overlay transition-colors duration-150"
                        onClick={() => action.actionHandler(row)}
                      >
                        <FontAwesomeIcon
                          icon={action?.icon}
                          className="text-xs"
                        />
                        {action.name}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Transition>
          </Menu>
          )}
        </td>
      )}
    </tr>
  );
};

export default RenderRow;
